import req from 'shared/req';
import JWTService from 'src/services/JWTService';
import {CoreEducationPhase} from 'src/constants';

const BASE_URL = '/v1/internal/partners';

export interface PartnerProvisioningRecord {
  universityId: string;
  collegeListingId?: string;
  name?: string;
  slug?: string;
  ipedsId?: number;
  ephemeral: boolean;
  tenantDomain?: string;
}

export interface PartnerProvisioningIndexResponse {
  partners: PartnerProvisioningRecord[];
  canTeardown: boolean;
}

export interface CreatePartnerPayload {
  ipedsId?: number;
  name?: string;
  alias?: string;
  tenantDomain?: string;
  tenantId?: string;
  headerKitDomain?: string;
  samlIdpMetadataDomain?: string;
  educationPhasesDownloadable: CoreEducationPhase[];
}

export interface TeardownPartnerPayload {
  ipedsId?: number;
  universityId?: string;
}

const authHeaders = async () => {
  const token = await JWTService.token();
  return {Authorization: `Bearer ${token}`};
};

const index = async (): Promise<PartnerProvisioningIndexResponse> => {
  const headers = await authHeaders();
  return req<PartnerProvisioningIndexResponse>({
    method: 'get',
    url: BASE_URL,
    headers,
  });
};

const create = async (payload: CreatePartnerPayload): Promise<{universityId: string}> => {
  const headers = await authHeaders();
  return req<{universityId: string}>({
    method: 'post',
    url: BASE_URL,
    headers,
    data: payload,
  });
};

const teardown = async (payload: TeardownPartnerPayload) => {
  const headers = await authHeaders();
  await req({
    method: 'delete',
    url: BASE_URL,
    headers,
    data: payload,
  });
};

export default {
  index,
  create,
  teardown,
};
